import { Container, Section } from "@/components/ui/section";
import { Globe, Brain, FileText, Send, MessageSquare, Sparkles } from "lucide-react";

const steps = [
  {
    number: "1",
    icon: Globe,
    title: "Connect your business",
    description: "Enter your website URL and LinkedIn page. Casey performs a deep analysis of your offering, products, solutions, benefits, and ROI."
  },
  {
    number: "2",
    icon: FileText,
    title: "Get tailored interview kits",
    description: "Based on your desired outcome — case study, testimonial, or user story — Casey generates customized interview flows."
  },
  {
    number: "3",
    icon: Send,
    title: "Invite your customers",
    description: "Share a link manually or connect your CRM to automatically invite customers. No scheduling needed."
  },
  {
    number: "4",
    icon: MessageSquare,
    title: "Customers get interviewed",
    description: "Casey conducts natural, adaptive conversations. Every interview is transcribed and can be recorded."
  },
  {
    number: "5",
    icon: Sparkles,
    title: "Generate collateral instantly",
    description: "Casey transforms conversations into case studies, testimonials, quotes, and sales assets — ready to use."
  }
];

export const HowItWorks = () => {
  return (
    <Section id="how-it-works" className="bg-muted/20">
      <Container>
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
            How Casey works
          </h2>
          <p className="text-lg text-muted-foreground">
            From onboarding to published collateral — in five simple steps.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative flex gap-6 pb-12 last:pb-0">
              {/* Vertical line connector */}
              {index < steps.length - 1 && (
                <div className="absolute left-6 top-14 w-0.5 h-[calc(100%-3.5rem)] bg-gradient-to-b from-primary/50 to-primary/10" />
              )}
              
              {/* Step number with icon */}
              <div className="relative z-10 flex-shrink-0">
                <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center text-primary-foreground shadow-lg">
                  <step.icon className="w-5 h-5" />
                </div>
              </div>
              
              {/* Content */}
              <div className="flex-1 bg-card border border-border rounded-xl p-6 hover:shadow-[var(--shadow-soft)] transition-all duration-300">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-sm font-semibold text-primary bg-primary/10 px-2.5 py-0.5 rounded-full">
                    Step {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};
